<template>
  <AppAlert variant="neutral" hide-icon>
    <div class="disconnected-fb-alert">
      <button
        type="button"
        class="disconnected-fb-alert__header"
        :aria-expanded="expanded"
        @click="expanded = !expanded">
        <i class="disconnected-fb-alert__icon fa-brands fa-facebook" />
        <span class="disconnected-fb-alert__summary">
          <template v-if="isSingle">
            Your Facebook account &ldquo;{{ singleAccount.profileName }}&rdquo;<template v-if="singleAccount.email"> ({{ singleAccount.email }})</template>
            was disconnected on {{ singleAccount.disconnectedAt }}
          </template>
          <template v-else>
            Your Facebook accounts {{ accountNames }} were disconnected
          </template>
        </span>
        <i class="disconnected-fb-alert__chevron fa-solid" :class="expanded ? 'fa-chevron-up' : 'fa-chevron-down'" />
      </button>

      <div v-if="expanded" class="disconnected-fb-alert__body">
        <template v-if="data.affectedBusinesses.length === 0">
          <p>
            Although {{ isSingle ? 'this account isn’t' : 'these accounts aren’t' }} currently connected to a business,
            it must be reconnected to enable future publishing to Facebook or Instagram.
          </p>
          <div class="disconnected-fb-alert__actions">
            <a
              :href="data.reconnectUrl"
              target="_blank"
              rel="noopener"
              class="disconnected-fb-alert__link">
              Reconnect Account
            </a>
            <template v-if="data.isLinda">
              <span>|</span>
              <a :href="data.helpCenterUrl" class="disconnected-fb-alert__link">View Help Guide</a>
            </template>
          </div>
        </template>
        <template v-else>
          <p>You won&rsquo;t be able to publish any local posts to Facebook or Instagram for these businesses:</p>
          <ul class="disconnected-fb-alert__businesses">
            <li v-for="b in data.affectedBusinesses" :key="b.path">
              <a
                :href="b.path"
                target="_blank"
                rel="noopener"
                class="disconnected-fb-alert__link">{{ b.name }}</a>
            </li>
          </ul>
          <p>
            <a
              :href="data.reconnectUrl"
              target="_blank"
              rel="noopener"
              class="disconnected-fb-alert__link">Reconnect now</a>
            to keep your social media content active and visible to your local audience.
          </p>
        </template>
      </div>
    </div>
  </AppAlert>
</template>

<script setup>
import { ref, computed } from 'vue'
import { AppAlert } from '@/components/ui'

const props = defineProps({
  data: { type: Object, required: true }
})

const expanded = ref(false)
const isSingle = computed(() => props.data.accounts.length === 1)
const singleAccount = computed(() => props.data.accounts[0])
const accountNames = computed(() => props.data.accounts.map((a) => `“${a.profileName}”`).join(', '))
</script>
